module.exports = __webpack_public_path__ + "977be2b0630ea16eaa2fa01e05d8d0aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-orange-s.png
// module id = 1915
// module chunks = 0